export const AcademicOptions = [
  {
    label: '小学',
    value: 0
  },
  {
    label: '初中',
    value: 1
  },
  {
    label: '高中',
    value: 2
  },
  {
    label: '大专',
    value: 3
  },
  {
    label: '本科',
    value: 4
  },
  {
    label: '硕士',
    value: 5
  },
  {
    label: '博士',
    value: 6
  }
];



// WEBPACK FOOTER //
// ./src/resources/academics.js